import React from 'react'
import SideBarMenu from './sideBar-menu'

export default (props) => {
	return <SideBarMenu {...props} />
}
